import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {

  // Default theme
  public static default = 'light';

  // Getter for the current theme
  public get current(): string {
    return localStorage.getItem('theme') ?? ThemeService.default;
  }

  // Setter for the current theme
  public set current(value: string) {
    localStorage.setItem('theme', value);
    this.updateThemeLink(value);
  }

  // Style element for the theme
  private readonly style: HTMLLinkElement;

  constructor() {
    // Create a style element for the theme
    this.style = document.createElement('link');
    this.style.rel = 'stylesheet';
    document.head.appendChild(this.style);

    // Set the theme based on local storage
    if (localStorage.getItem('theme') !== undefined) {
      this.updateThemeLink(this.current);
    }

    // Listen for changes to the system color scheme
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
      this.setSystemTheme();
    });
  }

  // Set the theme based on the system color scheme
  setSystemTheme(): void {
    const darkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
    this.current = darkMode ? 'dark' : 'light';
  }

  // Update the theme link
  private updateThemeLink(theme: string): void {
    this.style.href = `${theme}.css`;
  }
}